import { createContext } from 'react';

export const SurveyContext = createContext();
